import React from "react";
import { Modal, Button } from "react-bootstrap";

const FileDeleteModal = ({
  setShowDeleteModal,
  showDeleteModal,
  handleOnClick,
}) => (
  <>
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      size="md"
      show={showDeleteModal}
      onHide={() => setShowDeleteModal(false)}
      centered
      backdropClassName="custom-modal-backdrop"
      dialogClassName="custom-modal-dialog"
      style={{ zIndex: 999999 }}
    >
      <Modal.Body>
        <h6>Do you want to delete the file?</h6>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setShowDeleteModal(false)}>No</Button>
        <Button onClick={handleOnClick}>Yes</Button>
      </Modal.Footer>
    </Modal>
  </>
);

export default FileDeleteModal;
